// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2641":"a70a9a01","3762":"a70a9a01","8239":"a70a9a01","8316":"a70a9a01"}[chunkId] + ".chunk.css";
};